import { SEARCH_RESULTS_SETTINGS_DEFAULTS } from './constants';
export var getSettingsDefaultValue = function (key) {
    return SEARCH_RESULTS_SETTINGS_DEFAULTS[key];
};
export function getSettingsValueOrDefault(key, getSettingsRawValue) {
    var value = getSettingsRawValue(key);
    if (typeof value !== 'undefined') {
        return value;
    }
    return getSettingsDefaultValue(key);
}
//# sourceMappingURL=getSettingsValueOrDefault.js.map